import React, { SVGProps } from 'react';

export const Save = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M15.873 1.2a3 3 0 0 1 2.121.879l3.927 3.926a3 3 0 0 1 .879 2.122V19.8a3 3 0 0 1-3 3H4.2a3 3 0 0 1-3-3V4.2a3 3 0 0 1 3-3h11.673ZM4.2 21h1.2v-2.4a3 3 0 0 1 3-3h7.2a3 3 0 0 1 3 3V21h1.2a1.2 1.2 0 0 0 1.2-1.2V8.127a1.2 1.2 0 0 0-.352-.849l-3.926-3.927A1.2 1.2 0 0 0 15.873 3H13.8v4.2A1.8 1.8 0 0 1 12 9H7.2a1.8 1.8 0 0 1-1.8-1.8V3H4.2A1.2 1.2 0 0 0 3 4.2v15.6A1.2 1.2 0 0 0 4.2 21Zm3-18v4.2H12V3H7.2Zm9.6 15.6a1.2 1.2 0 0 0-1.2-1.2H8.4a1.2 1.2 0 0 0-1.2 1.2V21h9.6v-2.4Z"
    />
  </svg>
);
